import { Fragment, FC } from 'react'
import times from 'lodash/times'
import styled, { css } from 'styled-components'
import BookMark from 'svgIcons/BookMark'

interface LoadingItemProps {
  className?: string
}

const LoadingItem: FC<LoadingItemProps> = ({ className }) => {
  return (
    <StyledWrapper className={className}>
      <span className="skeleton-image" />
      <div className="content-box">
        <div className="text-skeleton-box">
          <span className="skeleton-text" style={{ width: '100px' }} />
          <span className="skeleton-text" style={{ width: '130px' }} />
          <span className="secondary-skeleton-box">
            <span className="skeleton-text" style={{ width: '30px' }} />
            <span className="skeleton-text" style={{ width: '30px' }} />
            <span className="skeleton-text" style={{ width: '30px' }} />
          </span>
        </div>
        <div>
          <BookMark className="bookmark-icon" />
        </div>
      </div>
    </StyledWrapper>
  )
}

interface LoadingListItemProps {
  length: number
  className?: string
}

const LoadingListItem: FC<LoadingListItemProps> = ({ length, ...props }) => {
  const loadingItems = times(length)

  return (
    <StyledWrapper>
      {loadingItems.map((item) => (
        <Fragment key={item}>
          <LoadingItem {...props} className="container" />
        </Fragment>
      ))}
    </StyledWrapper>
  )
}

export default LoadingListItem

const StyledWrapper = styled.div`
  .container {
    @keyframes skeleton {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0.4;
      }
      100% {
        opacity: 1;
      }
    }

    background-color: white;
    display: flex;
    width: 100%;
    align-items: center;
    padding: 15px 10px 15px 0px;
    ${({ theme }) =>
      theme.isMobile &&
      css`
        padding-left: 20px;
      `}
  }

  .content-box {
    flex-grow: 1;
    display: flex;
    min-width: 0px;
    align-items: center;
  }

  .text-skeleton-box {
    display: flex;
    gap: 5px;
    flex-grow: 1;
    max-width: 100%;
    min-width: 0%;
    align-items: flex-start;
    margin-right: 30px;
    flex-direction: column;
  }

  .secondary-skeleton-box {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .skeleton-text {
    height: 22px;
    flex-shrink: 0;
    transform: scale(1, 0.6);
    border-radius: 4px;
    display: block;
    background-color: rgba(51, 51, 51, 0.11);
    animation: skeleton 1.5s ease-in-out 0.5s infinite;
  }

  .skeleton-image {
    width: 60px;
    height: 100px;
    margin-right: 15px;
    flex-shrink: 0;
    transform: scale(1, 0.6);
    border-radius: 4px;
    display: block;
    background-color: rgba(51, 51, 51, 0.11);
    animation: skeleton 1.5s ease-in-out 0.5s infinite;
  }

  .bookmark-icon {
    width: 15px;
    color: #e8e8e8;
    margin: 12px;
  }
`
